import { render, staticRenderFns } from "./Modify_Recored.vue?vue&type=template&id=141becdc&"
import script from "./Modify_Recored.vue?vue&type=script&lang=js&"
export * from "./Modify_Recored.vue?vue&type=script&lang=js&"
import style0 from "./Modify_Recored.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports